import React from "react";
import { Link } from "react-router-dom";
import { Music, Mic, Drama, Tent, PersonStanding, Palette, PartyPopper, Castle, Speaker, Lightbulb, Theater, UtensilsCrossed, LayoutGrid } from "lucide-react";

const CATS = [
  ["artist", "Gruppi musicali e band", Music, "#7B4FB5"],
  ["artist", "Cantanti e interpreti", Mic, "#3F6FD8"],
  ["artist", "Teatro e recitazione", Drama, "#E0464E"],
  ["artist", "Artisti circensi e di strada", Tent, "#F07A2B"],
  ["artist", "Arti visive e creatività dal vivo", Palette, "#17A398"],
  ["artist", "Danza e ballo", PersonStanding, "#D9407F"],
  ["artist", "Spettacoli per bambini e famiglie", PartyPopper, "#3BAA5C"],
  ["artist", "Folklore e rievocazioni storiche", Castle, "#9A6B3F"],
  ["supplier", "Service audio e fonica", Speaker, "#2D8FD1"],
  ["supplier", "Service luci e illuminotecnica", Lightbulb, "#E3A21A"],
  ["supplier", "Palchi, strutture e scenotecnica", Theater, "#5A5FC8"],
  ["supplier", "Catering, bar e somministrazione", UtensilsCrossed, "#E2651F"],
];

const Tile = ({ to, label, Icon, color, id }) => (
  <Link to={to} data-testid={`home-cat-${id}`} className="group flex flex-col items-center text-center gap-2 w-24 shrink-0 snap-start">
    <span className="w-14 h-14 rounded-2xl flex items-center justify-center text-white shadow-md group-hover:-translate-y-1 group-hover:shadow-lg transition-[transform,box-shadow] duration-300" style={{ background: color }}>
      <Icon className="w-7 h-7"/>
    </span>
    <span className="text-xs leading-tight text-aic-navy font-medium">{label}</span>
  </Link>
);

export const HomeCategories = () => (
  <section className="max-w-7xl mx-auto px-6 pt-10 pb-4" data-testid="home-categories">
    <div className="flex gap-5 overflow-x-auto no-scrollbar snap-x pb-2 lg:flex-wrap lg:justify-center lg:gap-x-6 lg:gap-y-6 lg:overflow-visible">
      {CATS.map(([a, m, Icon, c], i) => <Tile key={m} id={`${a}-${i}`} to={`/cerca?area=${a}&cat=${encodeURIComponent(m)}`} label={m} Icon={Icon} color={c}/>)}
      <Tile id="tutte" to="/cerca" label="Tutte le categorie" Icon={LayoutGrid} color="#0D2B5A"/>
    </div>
  </section>
);
